/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Package_Aroma_SamplingInputs */

const vi_tea_package_aroma_sampling = /** @type {(inputs: Tea_Package_Aroma_SamplingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lần lấy hương`)
};

/**

* @param {Tea_Package_Aroma_SamplingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_package_aroma_sampling = /** @type {((inputs?: Tea_Package_Aroma_SamplingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Package_Aroma_SamplingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_package_aroma_sampling(inputs)
});